/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Button } from '@radix-ui/themes';

import { use, useCallback } from 'fierry/react';

import Navigation from 'solis/navigation';
import Routes from 'solis/enum/route';


const OnClick = (event, dispatch, colonyID) =>
{
  dispatch.pushForeground({ route: Routes.Deploy.replace(':id', colonyID) });
};


const Component = ({ colonyID }) =>
{
  const dispatch = use(Navigation.Dispatch);

  const onClick = useCallback(OnClick, [ dispatch, colonyID ]);

  return <Button onClick = {onClick}>Deploy</Button>;
};


export default ({ colony, account }) =>
{
  if (colony.cass.user !== account.cass.id || colony.cass.board)
  {
    return null;
  }

  return <Component colonyID = {colony.cass.id} />;
};
